import { particles } from 'app/contracts/Particles';
import { LookupType, RepellType } from 'app/enum/Particles';
import { ParticleProgressParallax } from 'particles/behaviour/ParticleProgressParallax';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import DelayHelper from 'utils/timers';
import HomeScreens from 'app/views/home/webgl/particles/scenes/HomeScreens';

export default class ScreensParticleProcessor {
	constructor(
		private _p: HomeParticle,
		private _sceneProps: particles.ParticlesSceneProps
	) {}


	public tick() {
	}

	public testVisible() {
		return;
		this._p.particleProps.sprite.visible = HomeScreens.particleInScreenBounds(
			this._p.particleProps.sprite.x + this._sceneProps.mouse.particleContainersX.screens,
			this._p.particleProps.sprite.y,
			this._p.particleProps.sprite.width,
			this._p.particleProps.sprite.height
		);
	}

	public setFrame(config, resetAtStart: boolean = false): void {
		this._p.position.xOffset = 0;

		if (resetAtStart) {
			this._p.position.set({ x: config.x, y: config.y }, true);
		} else {
			this._p.position.lerp({ x: config.x, y: config.y }, 30);
		}
	}

	/**
	 * Set the properties particle while in screens scene as a frame item:
	 *
	 */
	public initScreensShape(reset: boolean = true, sizeReset: boolean = true): void {
		if (reset && sizeReset) this._p.position.set({ x: 0, y: 0.45 }, true);

		this._p.position.disableTimelineX = true;
		this._p.repell.target = this._sceneProps.targets.screensMouse;

		return;
		if (reset) {
			this._p.deactivateAllBehaviours(true);
		}

		this._p.repell.active = true;

		this._p.position.trackMouse = false;

		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.screensMouse;

		this._p.repell.testAtCount = 1;
		this._p.repell.radius = 10;

		this._p.repell.type = RepellType.POSITION;

		let pSeed = this._p.random(0, 3);
		this._p.repell.randomisePower(0.001 * pSeed, 0.002 * pSeed);
		this._p.repell.returnPower = { x: this._p.random(0.03, 0.09), y: this._p.random(0.03, 0.09) };

		this._p.mouseParallax.active = false;
		this._p.mouseParallax.setPower({ x: 0.015, y: 0.03 });

		this._p.animatedProps.setEase({
			x: this._p.random(2, 2),
			y: this._p.random(2, 2),
			scale: 4,
			alpha: 4
		});

		this._p.orbitPath.active = false;

		this._p.animatedProps.targetAlpha = this._p.random(0.3, 0.8);
		this._p.animatedProps.targetScale = this._p.random(0.1, 0.05);

		this._p.animatedProps.targetAlpha = 1;
		this._p.animatedProps.targetScale = this._p.random(0.1, 0.05);

		this._p.mouseParallax.active = true;
		this._p.mouseParallax.setPower({ x: 0.008, y: 0.015 });

		this._p.hover.active = false;
		this._p.hover.radius = 80;
		this._p.hover.setAlpha(this._p.animatedProps.targetAlpha, this._p.animatedProps.targetAlpha + 0.5);
		this._p.hover.setScale(this._p.animatedProps.targetScale, this._p.animatedProps.targetScale + 0.1);
		this._p.hover.target = this._sceneProps.targets.screensMouse;

		if (reset && sizeReset) this._p.position.set({ x: 0, y: 0.45 }, true);
	}

	public swirl(config, circleIndex, colourHex, shape = 'solid2.png', sceneconfig) {
		this._p.deactivateAllBehaviours(true);


		this._p.changeParticle(shape);

		this._p.activate();
		this._p.orbitPath.active = true;
		this._p.orbitPath.xMuliplier = config.r * sceneconfig[0].rscale;
		this._p.orbitPath.yMuliplier = config.r * sceneconfig[0].rscale;
		this._p.orbitPath.speed = 1;
		this._p.orbitPath.pathIndex = circleIndex;
		this._p.orbitPath.speedMuiliplier = 1;
		this._p.orbitPath.scaleActive = false;
		this._p.orbitPath.path = LookupType.CIRCLE;

		this._p.orbitPath.syncRotation = true;
		this._p.particleProps.sprite.blendMode = null;

		this._p.animatedProps.targetAlpha = this._p.animatedProps.alpha = 0.8 + Math.random() * 0.2;

		this._p.animatedProps._x.setVectorConfig(false);
		this._p.animatedProps._y.setVectorConfig(false);

		this._p.animatedProps.stopBreathing();

		let shapeFix = shape == 'solid-square.png' ? 0.75 : 1;
		let baseScale = config.s * sceneconfig[0].scale * shapeFix;
		this._p.animatedProps.hardSetScale(baseScale);

		this._p.animatedProps.scale = 0;
		this._p.colour.set(colourHex);

		this._p.animatedProps.setEase({
			x: 20 * config.s,
			y: 20 * config.s,
			scale: 20,
			alpha: 2
		});

		this._p.position.set(
			{
				x: sceneconfig[0].x,
				y: sceneconfig[0].y
			},
			true
		);

		this._orbitRepell();

		this._p.repell.returnTo = {
			x: sceneconfig[0].x,
			y: sceneconfig[0].y
		};

		DelayHelper.setTimeout(
			() => {
				this._p.orbitPath.xMuliplier = config.r * sceneconfig[1].rscale;
				this._p.orbitPath.yMuliplier = config.r * sceneconfig[1].rscale;
				this._p.orbitPath.direction = -1;
				this._p.orbitPath.speedMuiliplier = 0.25;
				this._p.animatedProps.targetScale = this._p.animatedProps.targetScaleSaved =
					config.s * sceneconfig[1].scale * shapeFix;

				//Remove whoozy:
				this._p.animatedProps._x.setVectorConfig(false);
				this._p.animatedProps._y.setVectorConfig(false);

				this._p.position.set({
					x: sceneconfig[1].x,
					y: sceneconfig[1].y
				});

				this._p.repell.returnTo = {
					x: sceneconfig[1].x,
					y: sceneconfig[1].y
				};

				this._p.animatedProps.setEase({
					x: 30 * config.s,
					y: 30 * config.s,
					scale: 20,
					alpha: 2
				});

				this._p.animatedProps.startBreathing(baseScale, 0.01, 0.5);
			},
			sceneconfig[1].t,
			null,
			'screens'
		);

		DelayHelper.setTimeout(
			() => {
				this._p.orbitPath.xMuliplier = config.r * sceneconfig[2].rscale;
				this._p.orbitPath.yMuliplier = config.r * sceneconfig[2].rscale;
				this._p.orbitPath.direction = 1;
				this._p.animatedProps.targetScale = this._p.animatedProps.targetScaleSaved = config.s * sceneconfig[2].scale;

				this._p.position.set({
					x: sceneconfig[2].x,
					y: sceneconfig[2].y
				});

				this._p.repell.returnTo = {
					x: sceneconfig[2].x,
					y: sceneconfig[2].y
				};
			},
			sceneconfig[2].t,
			null,
			'screens'
		);

		DelayHelper.setTimeout(
			() => {
				this._p.orbitPath.xMuliplier = config.r * sceneconfig[3].rscale;
				this._p.orbitPath.yMuliplier = config.r * sceneconfig[3].rscale;
				this._p.orbitPath.direction = -1;
				this._p.animatedProps.targetScale = this._p.animatedProps.targetScaleSaved = config.s * sceneconfig[3].scale;

				this._p.position.set({
					x: sceneconfig[3].x,
					y: sceneconfig[3].y
				});

				this._p.repell.returnTo = {
					x: sceneconfig[3].x,
					y: sceneconfig[3].y
				};

				this._p.animatedProps.setEase({
					x: 30,
					y: 30,
					scale: 30,
					alpha: 2
				});
			},
			sceneconfig[3].t,
			null,
			'screens'
		);
	}

	public leftDrop() {
		this._p.counter.active = true;
		this._p.counter.millsecsToFrames(Math.random() * 3000);
		this._p.counter.start();

		this._p.counter.onTrigger = () => {
			this._p.deactivateAllBehaviours(true);
			this._p.particlePhysics.active = true;
			this._p.particlePhysics.leftDrop();

			this._p.repell.active = true;
			this._p.repell.type = RepellType.VECTOR;
			this._p.repell.testAtCount = 1;
			//Allow for 150px circle and very tight ring:
			this._p.repell.radius = 100;
			this._p.repell.randomisePower(0.00005, 0.0000001);

			this._p.animatedProps.setEase({
				scale: 4
			});
		};
	}

	//Burst is the physics burst:
	public burstUp() {
		this._p.deactivateAllBehaviours(true);
		this._p.particlePhysics.active = true;
		this._p.particlePhysics.burstUp();

	}

	public rain() {
		this._p.deactivateAllBehaviours(true);

		this._p.animatedProps.targetScale = 0.1 + Math.random() * 0.1;
		this._p.animatedProps.targetAlpha = 0.3 + Math.random() * 0.6;


		this._p.particlePhysics.active = true;
		this._p.particlePhysics.rain('screens');
	}

	public gravityBurst(finalPosition, gridPosition, type, bigRandom, frame, subType = null): void {
		this._p.deactivateAllBehaviours(true);

		if (Math.random() < 0) {
			this._p.animatedProps.setEase({
				x: this._p.random(30, 30),
				y: this._p.random(30, 30),
				scale: 30,
				alpha: 30
			});
		} else {
			this._p.animatedProps.setEase({
				x: this._p.random(10, 10),
				y: this._p.random(10, 10),
				scale: 30,
				alpha: 2
			});
		}

		this._p.repell.active = true;
		this._p.repell.type = RepellType.PUSH;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 300;
		this._p.repell.randomisePower(30, 50);



		this._p.mouseParallax.active = false;

		//Whale


		//General dev
		finalPosition.y += 0.14;

		//Platforms test
		finalPosition.x -= 0.055633;



		this._p.animatedProps.targetAlpha = this._p.animatedProps.alpha = gridPosition.alpha;


		//Circle

		this._p.animatedProps.targetScaleSaved = gridPosition.radius * 0.3;
		this._p.animatedProps.targetScale = this._p.animatedProps.targetScaleSaved;

		this._p.animatedProps.targetAlpha = gridPosition.alpha;

		this._p.position.set({ x: -0.06, y: 0.26 }, true);
		this._p.position.set(finalPosition);

		//Fade out!!

		//Fade example


		//Whoozy:

		this._p.animatedProps._x.setVectorConfig(true);
		this._p.animatedProps._y.setVectorConfig(true);


		let ran = Math.random();
		let change = ran < 0.75;
		change = true;

		if (change) {
			let xD, yD;

			if (ran < 1) {
				xD = -0.04;
				yD = 0.36;
			} else if (ran <= 0.5) {
				xD = 0.02;
				yD = 0.36;
			} else {
				xD = 0.07;
				yD = 0.02;
			}

			DelayHelper.setTimeout(
				() => {
					this._p.position.set({
						x: finalPosition.x + xD,
						y: finalPosition.y + yD
					});

				},
				1000 + Math.random() * 400,
				null,
				'screens'
			);

			DelayHelper.setTimeout(
				() => {
					this._p.position.set({
						x: finalPosition.x + 0.032,
						y: finalPosition.y + 0.4
					});

				},
				3000 + Math.random() * 400
			);
		}

		this._p.colour.set(gridPosition.rgba);

		return;

		let burstPosition = {
			x: 0 + gridPosition.x * 0.12,
			y: 0 + gridPosition.y * 0.5
		};

		let random = Math.random();

		let scale = 1;
		if (random < 0.33) {
			scale = 0.66;
		} else if (random < 0.66) {
			scale = 0.33;
		}

		random = bigRandom ? 60 : 20;
		let random2 = random;
		let holdRandom = 0;

		if (type == 1) {
			let step = Math.random() * 360;
			let radius = this._p.random(0.16, 0) * scale;
			radius = this._p.random(0.16, 0);
			let dx = Math.random() < 0.5 ? 1 : -1;
			let dy = Math.random() < 0.5 ? 1 : -1;
			burstPosition.x = finalPosition.x + (radius / 5) * Math.cos((2 * Math.PI * step) / 360) * dx;
			burstPosition.y = finalPosition.y + radius * Math.sin((2 * Math.PI * step) / 360) * dy;
		} else if (type == 2) {
			let step = Math.random() * 360;
			let radius = this._p.random(0, 0.16);
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;
			burstPosition.x = finalPosition.x + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
			burstPosition.y = finalPosition.y + radius * Math.sin((2 * Math.PI * step) / 360);
		} else if (type == 3) {
			let step = Math.random() * 360;
			let radius = this._p.random(0, 0.16);
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;
			burstPosition.x = frame.x + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
			burstPosition.y = frame.y + radius * Math.sin((2 * Math.PI * step) / 360);
		} else if (type == 4) {
			let step = Math.random() * 360;
			let radius = this._p.random(0.12, 0);
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;
			burstPosition.x = frame.x + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
			burstPosition.y = frame.y + radius * Math.sin((2 * Math.PI * step) / 360);
		} else if (type == 5) {
			let step = Math.random() * 360;
			let radius = this._p.random(0, 0.15);
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;
			burstPosition.x = frame.x + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
			burstPosition.y = frame.y + radius * Math.sin((2 * Math.PI * step) / 360);

			random = 0;
			holdRandom = 30;
			random2 = 30;
		} else if (type == 6) {
			let step = Math.random() * 360;
			let radius = this._p.random(0.12, 0);
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;
			burstPosition.x = frame.x + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
			burstPosition.y = frame.y + radius * Math.sin((2 * Math.PI * step) / 360);

			random = 30;
			holdRandom = 30;
			random2 = 0;
		} else if (type > 6 && type <= 9) {
			let step = Math.random() * 360;
			let radius;
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;

			if (subType == 1) {
				radius = 0.03;
				burstPosition.x = frame.x - 0.02 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y - 0.1 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 2) {
				radius = 0.01;
				burstPosition.x = frame.x + 0.005 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.12 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 3) {
				radius = 0.05;
				burstPosition.x = frame.x + 0.01 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.02 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 4) {
				radius = 0.02;
				burstPosition.x = frame.x - 0.027 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.04 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 5) {
				radius = 0.02;
				burstPosition.x = frame.x + 0.027 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y - 0.06 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			random = 20;
			holdRandom = 40;
			random2 = 20;
		} else if (type > 9 && type <= 11) {
			let step = Math.random() * 360;
			let radius;
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;

			if (subType == 1) {
				radius = this._p.random(0.01, 0.03);
				burstPosition.x = frame.x - 0.02 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y - 0.1 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 2) {
				radius = this._p.random(0.01, 0.01);
				burstPosition.x = frame.x + 0.005 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.12 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 3) {
				radius = this._p.random(0.01, 0.05);
				burstPosition.x = frame.x + 0.01 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.02 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 4) {
				radius = this._p.random(0.01, 0.02);
				burstPosition.x = frame.x - 0.027 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.04 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 5) {
				radius = this._p.random(0.01, 0.02);
				burstPosition.x = frame.x + 0.027 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y - 0.06 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			random = 20;
			holdRandom = 40;
			random2 = 20;
		} else if (type > 11) {
			let step = Math.random() * 360;
			let radius;
			Math.random() < 0.5 ? 1 : -1;
			Math.random() < 0.5 ? 1 : -1;

			if (subType == 1) {
				radius = 0.001;
				burstPosition.x = frame.x - 0.02 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y - 0.1 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 2) {
				radius = 0.001;
				burstPosition.x = frame.x + 0.005 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.12 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 3) {
				radius = 0.001;
				burstPosition.x = frame.x + 0.01 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.02 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 4) {
				radius = 0.001;
				burstPosition.x = frame.x - 0.027 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y + 0.04 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			if (subType == 5) {
				radius = 0.001;
				burstPosition.x = frame.x + 0.027 + (radius / 5) * Math.cos((2 * Math.PI * step) / 360);
				burstPosition.y = frame.y - 0.06 + radius * Math.sin((2 * Math.PI * step) / 360);
			}

			random = 20;
			holdRandom = 40;
			random2 = 20;
		}

		this._p.startCounter(this._p.counter, this._p.random(0, random), () => {
			this._p.animatedProps.setEase({
				x: 20,
				y: 20
			});
			this._p.position.set(burstPosition);

			this._p.startCounter(this._p.counter2, this._p.random(holdRandom, random2), () => {
				(this._p.position as ParticleProgressParallax).lerp(finalPosition, 60);
				(this._p.position as ParticleProgressParallax).effectLerpPerFrame = -1;
			});
		});
	}

	private _orbitRepell() {
		this._p.repell.active = true;
		this._p.repell.type = RepellType.POSITION;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 200;
		this._p.repell.randomisePower(0.001, 0);

		this._p.repell.returnTo = {
			x: -0.04,
			y: 0.5
		};

	}
}
